import React, { ReactNode } from 'react';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { useAuth } from '@clerk/clerk-react';

/**
 * Custom Apollo Provider that includes Clerk authentication
 * Automatically adds the auth token to every GraphQL request
 */
export function AuthenticatedApolloProvider({ children }: { children: ReactNode }) {
  const { getToken } = useAuth();

  const httpLink = createHttpLink({
    uri: (process.env.REACT_APP_API_URL || 'http://localhost:4000') + '/graphql',
  });

  const authLink = setContext(async (_, { headers }) => {
    // Get the authentication token from Clerk
    const token = await getToken();

    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    };
  });

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
